import React, { memo, Fragment } from "react";

import "./style.css";
import axios from "axios";
import { useEffect } from "react";
import { useState, useTransition } from "react";

import { Modal, Form, Input, Select, Row, Col, DatePicker } from "antd";

import { User, History, ChevronLeft, Edit } from "lucide-react";

import dayjs from "dayjs";
import { toast } from "sonner";

const UserForm = ({ initialValues, onCancel, onOk }) => {
  const [form] = Form.useForm();

  const [isPending, startTransition] = useTransition();

  const onFinish = (values) => {
    startTransition(async () => {
      try {
        await axios.put(
          `${import.meta.env.VITE_API_BOOKING}/api/user/${initialValues.id}`,
          {
            phone: values.phone,
            fullName: values.fullName,
            gender: values?.gender,
            email: values.email,
            dob: values.dob ? values.dob.toISOString() : null,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          },
        );

        toast.success("Cập nhật thông tin thành công");
        onOk();
      } catch (err) {
        toast.error(err?.response?.data?.error);
      }
    });
  };

  return (
    <Modal
      open
      onCancel={onCancel}
      title="Chỉnh sửa thông tin"
      centered
      width={800}
      onOk={() => form.validateFields().then(onFinish)}
      confirmLoading={isPending}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          customerCode: initialValues.customerCode,
          fullName: initialValues.fullName,
          phone: initialValues.phone,
          gender: initialValues.gender,
          personalType: initialValues.personalType,
          personalId: initialValues.personalId,
          dob: initialValues.dob ? dayjs(initialValues.dob) : undefined,
          email: initialValues.email,
        }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Số điện thoại" name="phone">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Họ và tên" name="fullName">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Ngày sinh" name="dob">
              <DatePicker
                placeholder="Chọn ngày sinh"
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Giới tính" name="gender">
              <Select
                placeholder="Chọn giới tính"
                options={[
                  { label: "Nam", value: "MALE" },
                  { label: "Nữ", value: "FEMALE" },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Email" name="email">
              <Input placeholder="Nhập email" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export const View = memo(({ faceId, onBack }) => {
  const [info, setInfo] = useState(null);

  const [currentUser, setCurrentUser] = useState(null);

  const getInfo = async () => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_API_BOOKING}/api/user/detail?faceIds=${faceId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );

      if (response.data?.length > 0) {
        setInfo(response.data?.[0]);
      }
    } catch (err) {
      if (err.response.status === 401) {
        toast.error("Hết thời gian đăng nhập vui lòng đăng nhập lại.");
        localStorage.removeItem("accessToken");
        window.location.reload();
        return;
      }
      console.log(err);
      toast.error(err?.response?.data?.error);
    }
  };

  useEffect(() => {
    getInfo();
  }, [faceId]);

  const onOkHandler = () => {
    setCurrentUser(null);
    getInfo();
  };

  return (
    <>
      <div className="view-profile">
        <div className="navigation" onClick={() => onBack()}>
          <ChevronLeft size={20} />
          Quay lại
        </div>
        <div className="view-profile-avatar">
          {info?.avatar ? (
            <img src={`data:image/jpg;base64,${info?.avatar}`} />
          ) : (
            <svg
              width="92"
              height="93"
              viewBox="0 0 92 93"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_279_2454)">
                <path
                  d="M46.0001 0.61853C20.7701 0.61853 0.289062 21.1025 0.289062 46.3335C0.289062 71.5645 20.7731 92.0485 46.0001 92.0485C71.2301 92.0485 91.7151 71.5645 91.7151 46.3335C91.7151 21.1025 71.2311 0.61853 46.0001 0.61853ZM46.0001 3.47793C69.6841 3.47793 88.8551 22.6499 88.8551 46.3329C88.8551 70.0159 69.6831 89.1879 46.0001 89.1879C22.3171 89.1879 3.14506 70.0159 3.14506 46.3329C3.14506 22.6499 22.3171 3.47793 46.0001 3.47793ZM46.0001 16.5639C37.1329 16.5639 29.9181 23.8022 29.9181 32.6889C29.9181 41.5756 37.1329 48.8139 46.0001 48.8139C54.8673 48.8139 62.0821 41.5756 62.0821 32.6889C62.0821 23.8022 54.8673 16.5639 46.0001 16.5639ZM46.0001 19.4194C53.3165 19.4194 59.2271 25.3413 59.2271 32.6854C59.2271 40.0295 53.3209 45.9514 46.0001 45.9514C38.6837 45.9514 32.7771 40.0295 32.7771 32.6854C32.7771 25.3413 38.6833 19.4194 46.0001 19.4194ZM46.0001 52.0364C33.6371 52.0364 22.2701 58.8333 16.4181 69.7244C16.0509 70.4158 16.3087 71.2791 17.0001 71.6541C17.6915 72.0252 18.5548 71.7635 18.9298 71.0721C24.2853 61.1033 34.6838 54.8881 45.9998 54.8881C57.3158 54.8881 67.7028 61.1029 73.0588 71.0721C73.2385 71.408 73.5432 71.658 73.9104 71.7674C74.2736 71.8768 74.6643 71.8338 75.0002 71.6541C75.6916 71.2791 75.9494 70.4158 75.5822 69.7244C69.7345 58.8334 58.3631 52.0364 46.0001 52.0364Z"
                  fill="url(#paint0_linear_279_2454)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_279_2454"
                  x1="0.289063"
                  y1="46.3335"
                  x2="91.7151"
                  y2="46.3335"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#639EB3" />
                  <stop offset="1" stop-color="#BE9EAA" />
                </linearGradient>
                <clipPath id="clip0_279_2454">
                  <rect
                    width="92"
                    height="92"
                    fill="white"
                    transform="translate(0 0.333374)"
                  />
                </clipPath>
              </defs>
            </svg>
          )}
          <h1>{info?.fullName}</h1>
        </div>
        <div className="view-profile-info">
          <div
            className="profile-heading"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <User style={{ color: "#669EB3" }} size={24} />
              Thông tin cơ bản
            </div>
            <div>
              <Edit
                style={{ cursor: "pointer" }}
                onClick={() => setCurrentUser(true)}
                size={16}
              />
            </div>
          </div>
          <div className="view-item-info-item">
            <span>Số điện thoại</span>
            <span>{info?.phone}</span>
          </div>
          <div className="view-item-info-item">
            <span>Ngày sinh</span>
            <span>
              {info?.dob ? dayjs(info?.dob).format("DD/MM/YYYY") : "---"}
            </span>
          </div>
          <div className="view-item-info-item">
            <span>Giới tính</span>
            <span>
              {info?.gender ? (info?.gender === "MALE" ? "Nam" : "Nữ") : "---"}
            </span>
          </div>
          <div className="view-item-info-item">
            <span>Email</span>
            <span>{info?.email ?? "---"}</span>
          </div>
          <div
            style={{
              background: "#ffffff80",
              height: 1,
              width: "100%",
              margin: "24px 0",
            }}
          />
          <div className="profile-heading">
            <History style={{ color: "#669EB3" }} size={24} />
            Lịch sử xét nghiệm
          </div>
          <div>
            {info?.history?.length > 0 ? (
              info?.history?.map((item, index) => (
                <Fragment key={item.order}>
                  {index > 0 && (
                    <div
                      style={{
                        background: "#8b838380",
                        height: 1,
                        width: "100%",
                        margin: "8px 0px",
                      }}
                    />
                  )}
                  <div style={{ fontSize: 14 }} className="">
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#00000073" }}>Mã đặt hẹn</span>
                      <span
                        style={{ fontWeight: 500 }}
                      >{`${item.order} - ${item?.date && dayjs(item?.date).format("DD/MM/YYYY")}`}</span>
                    </p>
                    <p
                      style={{
                        marginTop: 4,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#00000073" }}>Gói xét nghiệm</span>
                      <span style={{ fontWeight: 500 }}>
                        {item.packageName}
                      </span>
                    </p>
                    <p style={{ marginTop: 4, color: "#00000073" }}>Tái khám</p>
                    <ul style={{ paddingLeft: 16 }}>
                      <li>
                        {`Ngày khám: 
                        ${
                          item?.scheduleFollowAppointment?.date &&
                          dayjs(
                            item?.scheduleFollowAppointment?.date.split("T")[0],
                            "YYYY-MM-DD",
                          ).format("DD/MM/YYYY")
                        }`}
                      </li>
                      <li>
                        {`Nội dung: ${item?.scheduleFollowAppointment?.result}`}
                      </li>
                    </ul>
                  </div>
                </Fragment>
              ))
            ) : (
              <p className="empty">Chưa có lịch sử xét nghiệm</p>
            )}
          </div>
        </div>
      </div>
      {currentUser && (
        <UserForm
          initialValues={info}
          onOk={onOkHandler}
          onCancel={() => setCurrentUser(null)}
        />
      )}
    </>
  );
});
